import { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import {
  FormikInput,
  FormikSearchSelect,
} from "../../../../components/formik-components";

import { useNavigate } from "react-router-dom";
import { Button } from "../../../../components/ui/button";
import {
  respEnum,
  TournamentMatchStageEnum,
} from "../../../../constants/appConstant";
import Common from "../../../../helper/common";
import { Icon } from "@iconify/react";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../components/ui/dialog";

const FormikInitialValues = {};

const formikValidation = yup.object({
  points: yup.number().required("Point is required"),
  catid: yup.number().required("Category is required"),
  stagetype: yup.number().required("Stage Type is required"),
});

const AddRankingPoints = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  useEffect(() => {
    if (id) {
      getDataInfo();
    }
  }, [id]);
  useEffect(() => {
    const fetchData = async () => {
      getCategories();
    };
    fetchData();
  }, []);

  const getCategories = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetRankingCategory"
      );
      const data = [
        {
          id: null,
          name: "No Club",
        },
        ...response.data,
      ];

      setCategoryList(data);
    });
  };

  const onSubmitData = async (d, action) => {
    let data = {
      ...d,
      id,
    };

    let response = await Common.ApiService.getInstance().request(
      "AddUpdateRankingPoints",
      data,
      "POST"
    );

    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/RankingPoints", { replace: true });
      }
    }
  };

  const getDataInfo = async () => {
    debugger;
    let response = await Common.ApiService.getInstance().request(
      `GetRankingPoints?id=${id}`
    );
    if (response.status === respEnum.Success && response.data.length > 0) {
      const item = response.data[0];

      formikRef.current.setValues({
        ...item,
      });
    }
  };

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent ref={dialogRef}>
          <DialogHeader>
            <DialogTitle className="text-base font-medium ">
              {!id ? "Add" : "Update"} Ranking Points
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500  space-y-2 max-h-[450px] overflow-y-auto pr-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                  <div className="col-span-1">
                    <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                      <div className="flex flex-col gap-3">
                        <FormikSearchSelect
                          formikProps={formikProps}
                          name={"catid"}
                          placeholder={"Select"}
                          label={"Category"}
                          data={categoryList}
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikSearchSelect
                          formikProps={formikProps}
                          name={"stagetype"}
                          placeholder={"Select"}
                          label={"Type"}
                          data={[
                            { id: null, name: "Select" },
                            ...Common.Utility.enumToArray(
                              TournamentMatchStageEnum
                            ),
                          ]}
                          // onChange={handelSliderType}
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          name={"points"}
                          label={"Points"}
                          placeholder={"Points"}
                          //   maxLength="50"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </div>
          <DialogFooter className="mt-8 gap-2">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>

            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                  ? "Add"
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddRankingPoints;
